import type { ISimplifiedLicenseTypeStatus } from '$shared/interfaces/api/ISimplifiedLicenseTypeStatus';
import { schemaData } from '$shared/lib/data/SchemaData';
import BaseModel from './BaseModel';
import { LicenseSourceStatusModel } from './LicenseSourceStatusModel';
import { MaintenanceDowntimeCronDescription } from './MaintenanceDowntimeCronDescription';

export class SimplifiedLicenseTypeStatusModel extends BaseModel<ISimplifiedLicenseTypeStatus> {
  declare public status: LicenseSourceStatusModel;
  declare public maintenanceDowntimeCronDescription: MaintenanceDowntimeCronDescription[];

  public get licenseTypeId(): string {
    return this.response?.licenseTypeId;
  }

  public get state(): string {
    return this.response?.state;
  }

  public get stateNameWithCode(): string {
    return (
      (this.state && schemaData.State && `${schemaData.State[this.state]} (${this.state})`) || ''
    );
  }

  public get sourceName(): string {
    return this.response?.sourceName || '';
  }

  public get licenseTypeName(): string {
    return this.response?.licenseTypeName || '';
  }

  public get isActive(): boolean {
    return !this.status?.issue;
  }

  public get parsedSourceStatus(): string {
    return this.isActive ? 'Active' : this.status?.issue?.withSpaceAfterCapitalLetters();
  }

  public get parsedAverageProcessingTime(): string {
    return this.status?.parsedAverageProcessingTime || 'NA';
  }

  public get sourceIssueDesc(): string {
    return this.status?.sourceIssueDesc || '';
  }

  protected override transformResponse(): void {
    this.status = new LicenseSourceStatusModel(this.response?.status);
    this.maintenanceDowntimeCronDescription = (
      this.response?.maintenanceDowntimeCronDescription || []
    ).map((item) => new MaintenanceDowntimeCronDescription(item));
  }

  static getParsedSourceIssueLabel(type: string): string {
    if (!type) return '';
    return schemaData.SourceIssue[type]?.withSpaceAfterCapitalLetters() || type;
  }
}
